import { selectContacts } from './../../../shared/store/_features/contacts/contacts.selector';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import { ContactItem } from './models/contacts';
import {
  ContactsActions,
  NewContactActions,
  DeleteContactActions,
  UpdateContactActions,
} from 'src/app/shared/store/_features/contacts/contacts.actions';
import { CreateContactDto } from './create/dto/create-contact.dto';
import { ApiService } from 'src/app/shared/services';

@Injectable({
  providedIn: 'root',
})
export class SharedContactService {
  contacts: ContactItem[] = [];

  private _currentContact = new BehaviorSubject<any>(null);
  currentContact$ = this._currentContact.asObservable();
  get currentContact() {
    return this._currentContact.value;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private store: Store,
    private api: ApiService,
  ) {
    this.store.select(selectContacts).subscribe((contacts) => {
      this.contacts = contacts;
    });
  }

  async getContacts() {
    this.store.dispatch(ContactsActions.load());
  }

  async createContact(createPayload: CreateContactDto) {
    this.store.dispatch(NewContactActions.create({ createPayload }));
  }

  // Placeholder for delete - typically this would also dispatch an action
  async deleteContact(id: number, type: any = 'student') {
    this.store.dispatch(DeleteContactActions.delete({ id, contactType: type }));
  }

  async updateContact(id: number, payload: any, type: any = 'student') {
    this.store.dispatch(
      UpdateContactActions.update({
        itemId: id,
        item: payload,
        contactType: type,
      }),
    );
  }

  async loadContactProfile(id: number) {
    this._currentContact.next(null); // Reset
    try {
      const data = await this.api.getContactProfile(id).toPromise();
      this._currentContact.next(data);
    } catch (error) {
      console.error('Failed to load contact profile', error);
    }
  }

  updateCurrentContact(data: any) {
    // Update the current contact state directly without an API call
    // Ensure we maintain the structure { contact: ... } if the current value has it
    const currentValue = this._currentContact.value;
    if (currentValue && currentValue.contact) {
      this._currentContact.next({ ...currentValue, contact: data });
    } else {
      // Fallback if structure is different or empty (though typically expected structure is maintained in profile view)
      this._currentContact.next({ contact: data });
    }
  }

  getContactProfile(id: number) {
    return this.api.getContactProfile(id);
  }
}
